import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { FirebasePerformance } from '@capacitor-firebase/performance';

@Injectable({ providedIn: 'root' })
export class AppCrashlyticsService {
    constructor() {
        // this.initializeCrashlytics();
    }

    initializeCrashlytics() {
        FirebaseCrashlytics.setEnabled({ enabled: true });
    }

    initFirePerformace() {
        FirebasePerformance.setEnabled({ enabled: true });
    }

    async addedCustomtraces(type: 'start' | 'end', traceName: string) {
        if (type === 'start') {
            await FirebasePerformance.startTrace({ traceName: traceName });
        } else {
            await FirebasePerformance.stopTrace({ traceName: traceName });
        }
    }
}
